"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonProgressbar = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var ButtonProgressbar = function (_a) {
    var id = _a.id, completed = _a.completed, small = _a.small, medium = _a.medium, large = _a.large;
    return (react_1.default.createElement(styles_1.ButtonProgressContainerStyled, { id: id, small: small, medium: medium, large: large },
        react_1.default.createElement(styles_1.ButtonProgressFillerStyled, { style: { width: "".concat(completed, "%") }, small: small, medium: medium, large: large }),
        react_1.default.createElement(styles_1.ButtonProgressLabelStyled, { small: small, medium: medium, large: large }, "Publicando ".concat(completed, "%"))));
};
exports.ButtonProgressbar = ButtonProgressbar;
